import { render, staticRenderFns } from "./ContractOrCopy.vue?vue&type=template&id=299eb00a"
import script from "./ContractOrCopy.vue?vue&type=script&lang=js"
export * from "./ContractOrCopy.vue?vue&type=script&lang=js"
import style0 from "./ContractOrCopy.vue?vue&type=style&index=0&id=299eb00a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports